import React from 'react';
import preserveInputFocus from './preserveInputFocus.js';
import { resolveSkillIcon } from '../capabilities/capabilityIcons.jsx';

function resolveObject(value) {
  return value && typeof value === 'object' && !Array.isArray(value) ? value : null;
}

function resolveText(value) {
  return String(value ?? '').trim();
}

const TARGET_CHIP_DEFAULTS = Object.freeze({
  chip: null,
  onDismiss: null,
  themeTokens: { textSecondary: '#64748b' },
});

function renderDismissAction(onDismiss, themeTokens) {
  if (typeof onDismiss !== 'function') {
    return null;
  }
  return (
    <button
      aria-label="取消作用工作区"
      onClick={(event) => {
        event.preventDefault();
        onDismiss();
      }}
      onMouseDown={preserveInputFocus}
      style={{
        alignItems: 'center',
        background: 'transparent',
        border: 0,
        borderRadius: 8,
        color: themeTokens.textSecondary,
        cursor: 'pointer',
        display: 'inline-flex',
        fontSize: 13,
        height: 16,
        justifyContent: 'center',
        lineHeight: '16px',
        padding: 0,
        width: 16,
      }}
      type="button"
    >
      ×
    </button>
  );
}

export default function ComposerTargetChip(props) {
  const { chip, onDismiss, themeTokens } = { ...TARGET_CHIP_DEFAULTS, ...props };
  const targetChip = resolveObject(chip);
  const label = resolveText(targetChip?.label);
  if (!label) {
    return null;
  }
  return (
    <span
      className="flare-composer-target-chip"
      title={[resolveText(targetChip?.title), label].find(Boolean)}
      style={{
        alignItems: 'center',
        background: themeTokens.surfaceBgActive,
        border: 0,
        borderRadius: 8,
        color: themeTokens.textPrimary,
        display: 'inline-flex',
        fontSize: 12,
        fontWeight: 500,
        gap: 6,
        lineHeight: '20px',
        maxWidth: 180,
        minWidth: 0,
        overflow: 'hidden',
        padding: '0 8px',
        whiteSpace: 'nowrap',
      }}
    >
      {targetChip.skillPresentation ? <span style={{ display: 'inline-flex', flexShrink: 0 }}>
        {resolveSkillIcon(targetChip.skillPresentation)}
      </span> : null}
      <span
        style={{
          overflow: 'hidden',
          minWidth: 0,
          textOverflow: 'ellipsis',
        }}
      >
        {label}
      </span>
      {renderDismissAction(onDismiss, themeTokens)}
    </span>
  );
}
